import { IAuthRepository } from '../repository/AuthRepository'
import { IConsumePlayerApi } from '../api/ConsumePlayerApi'
import { setErrorPopupData } from '../../errorHandle/util/errorPopupUtil'
import { ErrorType } from '../../errorHandle/model/ErrorType'

export class ConsumePlayerService {
  private _authRepository: IAuthRepository
  private _api: IConsumePlayerApi

  constructor(authRepository: IAuthRepository, api: IConsumePlayerApi) {
    this._authRepository = authRepository
    this._api = api
  }

  consumePlayer = async (sessionToken: string | null): Promise<string> => {
    try {
      if (sessionToken !== null) {
        const authToken = await this._api.consumeToken(sessionToken)
        this._authRepository.setAuth(authToken)
        return authToken
      }
      else {
        return this._authRepository.getAuth()
      }
    }
    catch (error) {
      setErrorPopupData(ErrorType.SessionExpired)
      throw error
    }
  }
}
